import { NgModule } from '@angular/core';
import { SearchCarComponent } from './views/search-car/search-car.component';
import { HomeComponent } from './layout/home-layout/home.component';
import { TestimonialComponent } from './views/testimonial/testimonial.component';
import { PartnersComponent } from './views/partners/partners.component';
import { IntroComponent } from './views/intro/intro.component';
import { SharedModule } from '../../shared/shared.module';
import { OwnershipComponent } from './views/ownership/ownership.component';
import { HomeFiltersComponent } from './views/home-filters/home-filters.component';
import { FeaturedCarsComponent } from './views/featured-cars/featured-cars.component';
import { SharedViewsModule } from '../shared-views/shared-views.module';

@NgModule({
  declarations: [
    HomeComponent,
    SearchCarComponent,
    TestimonialComponent,
    PartnersComponent,
    IntroComponent,
    OwnershipComponent,
    HomeFiltersComponent,
    FeaturedCarsComponent,
  ],
  imports: [
    SharedModule,
    SharedViewsModule,
  ],
})
export class HomeModule { }
